import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';

import GlobalStyles from 'styles/GlobalStyles';
import Footer from 'components/Footer';
import Header from 'components/Header';
import SVGFilters from 'components/SVGFilters';
import menus from 'content/menus';

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

function Layout({ children, className }) {
  const menu = Object.fromEntries(menus.map((i) => [i.name, i]));
  const { pathname } = useLocation();

  const showSecondaryMenu = /^\/(resources|post\/[^/]+\/)(\/|$)/.test(pathname);
  const isHeaderInset = pathname !== '/resources/';
  const showFooterCTA = [
    '/',
    '/reviews/',
    '/automations/',
    '/metrics/',
    '/integrations/',
    '/soc2-compliance/',
    '/executives/',
    '/developers/',
    '/managers/',
  ].includes(pathname);

  return (
    <StyledLayout className={className}>
      <GlobalStyles />
      <SVGFilters />
      <Header
        menus={{
          primary: menu.primary,
          secondary: showSecondaryMenu && menu.secondary,
        }}
        inset={isHeaderInset}
      />
      <main>{children}</main>
      <Footer menu={menu.footer} withCta={showFooterCTA} />
    </StyledLayout>
  );
}

Layout.propTypes = {
  children: PropTypes.any,
};

Layout.defaultProps = {
  children: null,
};

export default Layout;
